import React from "react";
import moment from "moment";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import {Button} from "reactstrap";
import Tooltip from "@material-ui/core/Tooltip";
import {Collections, Elements, Parts} from "components";
import API from "@beardeddevops/react.api";
import TransactionObject from "components/TransactionObject";
import UniversalModalOverride from "components/UniversalModalOverride";


/**
 *  @property {Manufactureds_Object} state
 *  @property {object} model
 *  @property {Manufactureds_Properties} model.properties
 *  @property {Manufactureds_Is} model.is
 *  @property {Manufactureds_Has} model.has
 */
export default class ManufacturedObject extends TransactionObject {
	constructor(props) {
		super(props, Types.Manufactureds._name);

		// noinspection JSPrimitiveTypeWrapperUsage
		this.model.properties.serial_number.required = false;
		this.skuLookupModel = new API.BuildClass(Types.Products._name, 'GET_SKU');

		//Set UI only fields
		this.state.range_start = "";
		this.state.range_end = "";

		//Set default values as needed
		this.state.serial_numbers = [];
		this.state.used_firearm = false;
		this.state.type_previous = 9;
		this.state.type = 3;

		this.state.transaction_entriess = [];

		this.state.products = [];
	}

	/**
	 * @param prevProps
	 * @param {Transactions_Collections_Object} prevState
	 * @param snapshot
	 */
	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);

		/** @type {Manufactureds_Object} object */
		let object = this.state;

		//If Pkey has always been blank || this isn't the initial load so pkey is the same
		if (prevState.pkey === object.pkey) {
			//If "Location" select was updated, update corresponding Location Information
			if (object.locations && object.location !== prevState.location) {
				this.setState({'bound_book': ''});
			}
		}

		// Initialize "date" if it doesn't exist
		if (!object.date) {
			this.setState({date: moment().format('YYYY-MM-DD HH:mm:ss')});
		}
	}

	handleProcess(event, requestOverride) {
		let valid = true;

		/** @type {Manufactureds_Object} object */
		let object = this.state;

		//let serial_numbers = [...new Set(this.state.serial_numbers)].filter(Boolean);
		if ((this.state.transaction_entriess === null || this.state.transaction_entriess.length === 0) && this.state.pkey === null) {
			API.Toast.warn('A product is required.', {
				position: API.Toast.POSITION.TOP_CENTER,
				autoClose: 4000
			});
			valid = false;
		}
		if (!object.caliber && !object.caliber_other) {
			this.setState({caliber_other_error: 'Must have a caliber.'});
			valid = false;
		}
		if (!object.manufacturer && !object.manufacturer_other) {
			this.setState({manufacturer_other_error: 'Must have a manufacturer.'});
			valid = false;
		}
		return valid && super.handleProcess(event, requestOverride);
	};

	async handleSubmit(event, suppressToast = false) {
		this.setState({serial_numbers_error: ''});
		this.state.serial_numbers = [...new Set(this.state.serial_numbers)].filter(Boolean);
		await super.handleSubmit(event, suppressToast);
	};

	/**
	 * Return TRUE to prevent handleSubmit from running afterSave(data) if already ran in the override here.
	 * @param data
	 * @param request
	 * @param suppressProcess
	 * @returns {Promise<void>}
	 */
	async afterSubmit(data, request, suppressProcess = false) {
		this.props.history.push('/acquisitions/' + data._id);
	};

	addProducts = (products) => {
		if (!this.state.pkey && products.length > 0) {
			let entries = [...this.state.transaction_entriess, ...products.map(product => {
				return {product: product.pkey, products: product}
			})];
			this.setState({transaction_entriess: entries});

			let productKeys = [...this.state.products, ...products.map(product => {
				return product.pkey
			})];

			/** @type {Products_Object} product */
			let product = products[0];
			this.setState({
				products: productKeys,
				manufacturer: product.manufacturer,
				manufacturer_other: product.manufacturer_other,
				model: product.model,
				caliber: product.caliber,
				caliber_other: product.caliber_other,
				barrel_length: product.barrel_length,
				overall_length: product.overall_length,
				cost: product.cost,
				price_min: product.price_min,
				price_list: product.price_list,
				price_sale: product.price_sale,
			});
		}
	};

	deleteProduct = (entry, entry_binary_id, product, product_binary_id) => {
		let entries = this.state.transaction_entriess.filter(obj => obj.product !== product);
		this.setState({transaction_entriess: entries});
	};

	handleProductLookup = async () => {
		let {sku} = this.state;

		this.skuLookupModel.object.sku = sku;

		let product = await this.skuLookupModel.submit(null, 'GET_SKU');

		this.setState(product);
	}

	filterLocationOptions = (option) => !option.archived && option.has_manufacturing_module;

	//Note: Doesn't need a form() function. Only ever used in a modal
	render() {
		/** @type {Manufactureds_Properties} properties */
		let properties = this.model.properties;
		/** @type {Manufactureds_Object} object */
		let object = this.state;
		let {loading} = this.state;

		return (
			<div>
				<fieldset>
					<div className={"row"}>
						{/*#region Col 1*/}
						<div className={"col-md"}>
							{/*#region ATF Required Information*/}
							<h4 className="section-title">Details</h4>
							<Parts.SelectLocation
								object={object}
								properties={properties}
								shouldLoad={this.state.loaded}
								onSelectUpdate={this.handleSelectPropertyUpdate}
								locations={this.props.locations}
								states={this.props.states}
								filter={this.filterLocationOptions}
							/>
							{object.location ?
								<Parts.SelectBoundBook
									object={object}
									properties={properties}
									shouldLoad={this.state.loaded}
									onSelectUpdate={this.handleSelectPropertyUpdate}
								/> : null}

							<div className={'form-group'}>
								<div className="row">
									<div className="col-12">
										<Framework.Elements.Date
											appendTime={true}
											property={properties.date}
											value={object.date}
											error={object.date_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>
							<div className="form-group">
								<div className="row">
									<div className="col-6">
										<Framework.Elements.Select
											shouldLoad={this.state.loaded}
											update={this.handleSelectPropertyUpdate}
											property={properties.type_previous}
											value={object.type_previous}
											error={object.type_previous_error}
											model={Types.Products_Types._name}
											label={"Original Type"}
											nullable={false}
											limit={null}
										/>
									</div>
									<div className="col-6">
										<Framework.Elements.Select
											shouldLoad={this.state.loaded}
											update={this.handleSelectPropertyUpdate}
											property={properties.type}
											value={object.type}
											error={object.type_error}
											model={Types.Products_Types._name}
											id={'name'}
											label={"New Type"}
											nullable={false}
											limit={null}
										/>
									</div>
								</div>
							</div>

							{
								(object.type === 'Rifle' || object.type === 'Rifle / Shotgun') &&
								<div style={{marginTop: '-10px', marginBottom: '1rem', textAlign: 'right'}}>
									<p style={{marginBottom: '2px', color: 'grey', fontStyle: 'italic', fontSize: '12px'}}>Semi-automatic rifle with a
										detachable magazine?</p>
									<Framework.Elements.ButtonSwitch
										property={properties.semi_auto_w_detach}
										value={object.semi_auto_w_detach}
										error={object.semi_auto_w_detach_error}
										update={this.handleTextFieldPropertyUpdate}
										labelTrue={'Yes'}
										labelFalse={'No'}
									/>
								</div>
							}

							<div className="form-group">
								<Framework.Elements.TextField
									label={"Bound Book Notes"}
									value={object.item_description}
									error={object.item_description_error}
									property={properties.item_description}
									update={this.handleTextFieldPropertyUpdate}
									multiline={4}
								/>
							</div>
							{/*<div className="form-group">*/}
							{/*	<Framework.Elements.TextField*/}
							{/*		label={"Serial Number"}*/}
							{/*		value={object.serial_number}*/}
							{/*		error={object.serial_number_error}*/}
							{/*		property={properties.serial_number}*/}
							{/*		update={this.handleTextFieldPropertyUpdate}*/}
							{/*	/>*/}
							{/*</div>*/}
							<div className="form-group">
								<div className={"row"}>
									<div className={"col-md-9"}>
										<Framework.Elements.TextField
											label={"SKU or UPC"}
											value={object.sku}
											error={object.sku_error}
											property={properties.sku}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
									<div className={"col-md-3 text-right"}>
										<Button
											size={"md"}
											color="green-meadow"
											onClick={this.handleProductLookup}>
											Lookup
										</Button>
									</div>
								</div>
							</div>
							{/*#endregion*/}
						</div>
						{/*#endregion*/}
						{/*#region Col 2*/}
						<div className={"col-md"}>
							{/*#region Product Details*/}
							<h4 className="section-title">New Manufactured Details</h4>
							<div className="form-group">
								<Framework.Elements.Select
									shouldLoad={this.state.loaded}
									update={this.handleSelectPropertyUpdate}
									property={properties.manufacturer}
									value={object.manufacturer}
									error={object.manufacturer_error}
									model={Types.Manufacturers._name}
									nullable={true}
									limit={null}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									value={object.manufacturer_other}
									error={object.manufacturer_other_error}
									property={properties.manufacturer_other}
									update={this.handleTextFieldPropertyUpdate}
									label={"Manufacturer (Manual Entry)"}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									value={object.model}
									error={object.model_error}
									property={properties.model}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.Select
									shouldLoad={this.state.loaded}
									update={this.handleSelectPropertyUpdate}
									property={properties.caliber}
									value={object.caliber}
									error={object.caliber_error}
									model={Types.Calibers._name}
									nullable={true}
									limit={null}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									value={object.caliber_other}
									error={object.caliber_other_error}
									property={properties.caliber_other}
									update={this.handleTextFieldPropertyUpdate}
									label={"Caliber (Manual Entry)"}
								/>
							</div>
							<div className={"row"}>
								<div className={"col-md-6"}>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Barrel Length"}
											value={object.barrel_length}
											error={object.barrel_length_error}
											property={properties.barrel_length}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
								<div className={"col-md-6"}>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Overall Length"}
											value={object.overall_length}
											error={object.overall_length_error}
											property={properties.overall_length}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>
							<div className={"row"}>
								<div className={"col-md-4"}>
									<h4 className="section-title">Cost</h4>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Cost"}
											value={object.cost}
											error={object.cost_error}
											property={properties.cost}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
								<div className={"col-md-4"}>
									<h4 className="section-title">Min Price</h4>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Min Price"}
											value={object.price_min}
											error={object.price_min_error}
											property={properties.price_min}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
								<div className={"col-md-4"}>
									<h4 className="section-title">List Price</h4>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"List Price"}
											value={object.price_list}
											error={object.price_list_error}
											property={properties.price_list}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>
							{/*#endregion*/}
						</div>
						{/*#endregion*/}
						{/*#region Col 3*/}
						<div className={"col-md"}>
							<h4 className="section-title">
								Items
								<div className="pull-right">
									<Tooltip
										title="Products you have previously acquired and disposed / transferred can be found here."
										aria-label="Products you have previously acquired and disposed / transferred can be found here.">
										<Button onClick={this.handleToggleModalLookup} size={"sm"} color="primary">
											<i className={"fa fa-barcode"}/>
											<span className="hidden-xs">&nbsp;&nbsp;Products</span>
										</Button>
									</Tooltip>

									<UniversalModalOverride
										locations={this.props.locations}
										states={this.props.states}
										history={this.props.history}
										name={"In Stock Products"}
										object={Collections.ProductsExisting}
										toggle={this.state.modalLookup}
										reportClose={this.handleReportProductClose}
										afterSave={this.addProducts}
										size={"xl"}
										objectProps={{
											originalType: object.type_previous
										}}
									/>

								</div>
							</h4>

							<div style={{
								overflowY: "scroll",
								paddingRight: "4px",
								maxHeight: "362px"
							}}>
								{object.transaction_entriess && object.transaction_entriess.map((entry, i) =>
									<Elements.Item
										key={i}
										entry={entry}
										product={entry.products}
										onDelete={this.deleteProduct}
										onUpdate={this.updateProduct}
										openModal={this.handleToggleProductModel('productUpdate' + i)}
										reportClose={this.handleReportModalClose('productUpdate' + i)}
										modalUpdate={this.state['productUpdate' + i]}
										locations={this.props.locations}
										states={this.props.states}
										history={this.props.history}
										locationManufacturer={object.dealer_name_company}

									/>)}

								<p style={{textAlign: 'center', color: 'grey'}}><i>{object.transaction_entriess.length} Total Items</i></p>
							</div>

						</div>
						{/*#endregion*/}
					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	}
}
